import { HttpErrorResponse } from '@angular/common/http'

/**
 * The reason a request failed, for logging next to the error itself.
 *
 * A request that never reached the server surfaces as `Http failure response
 * for <url>: 0 undefined` - Angular's `FetchBackend` has no status to report,
 * so the message says nothing about _why_. The caught `fetch` rejection is kept
 * on `HttpErrorResponse.error` and names the actual problem (`ENOTFOUND`,
 * `ECONNREFUSED`, a certificate error), which is the difference between a
 * diagnosable SSR failure and a dead end.
 */
export function httpFailureCause(error: unknown): unknown {
  if (!(error instanceof HttpErrorResponse)) return undefined

  // Typed `any` by HttpErrorResponse.
  const cause: unknown = error.error
  if (cause instanceof Error) {
    return cause.cause ?? cause
  }

  return cause ?? error.message
}
